import { useContext, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { getSubscriptionAccess } from '../utils/subscription';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user, loading } = useContext(UserContext);
  const subscriptionAccess = useMemo(() => getSubscriptionAccess(user), [user]);

  if (loading) return null; // or a loading spinner
  if (!user) return <Navigate to="/login" replace />;

  const mustContactAdmin = user?.role === 'user' && subscriptionAccess.mustContactAdmin;
  if (mustContactAdmin && location.pathname !== '/dashboard/contact-admin') {
    return <Navigate to="/dashboard/contact-admin" replace state={{ from: location.pathname }} />;
  }

  return children;
}
